import * as Sentry from "@sentry/react";
import React from "react";

import BillingErrorPage from "./BillingErrorPage";
import Billing from "./components/Billing";

import { companyBillingQuery, currentUserQuery } from "../../api/queries";
import type { SimplifiedQuery } from "../../api/queries/dataLoader";
import { dataLoader } from "../../api/queries/dataLoader";

// Data loader function
export const billingLoader = () => {
	const queries: (() => SimplifiedQuery)[] = [];
	queries.push(companyBillingQuery);

	return dataLoader([[currentUserQuery], queries]);
};

const BillingAdmin = () => {
	return (
		<Sentry.ErrorBoundary fallback={<BillingErrorPage />}>
			<Billing />
		</Sentry.ErrorBoundary>
	);
};

export default BillingAdmin;
